import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Globals } from '../globals';
import { map, catchError } from 'rxjs/operators';
import { ConfigurationsService } from 'src/app/Service/configurations.service';

@Injectable({
    providedIn: 'root'
})


export class DashBoardService {
    private httpHeader = new HttpHeaders();

    constructor(private http: HttpClient, private _global: Globals, private configService: ConfigurationsService) {

        this.httpHeader.append('Access-Control-Allow-Origin', '*');

    }

    // Method is used for Get Dashboard Details
    GetDashboardDetails(reqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Dashboard' + '/GetEnergymeterDetailsBasedonSite';
        return this.http.post(serviceCallURL, reqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for Add Company
    GetGraphDetails(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Dashboard' + '/GetEnergymeterDetailsByRange';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Update Meter parameter
    UpdateMeterParamValue(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'AssignEnergymeter' + '/UpdateMeterParamValue';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Get DashBoard Config Data
    GetDashboardConfigData(CompanyId: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'DashBoard' + '/GetDashboardConfigData?CompanyId=' + CompanyId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Get User wise DashBoardDetails
    GetUserwiseDashBoardDetails() {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'DashBoard' + '/GetUserwiseDashBoardDetails';
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Save Dashoard Config Data
    SaveDashoardConfigData(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'DashBoard' + '/SaveDashoardConfigData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Check Dashboard Name Exist
    CheckDashboardNameExist(DashboardName: string = '') {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'DashBoard' + '/CheckExistDashboardNameinDB?DashboardName=' + DashboardName;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp.Response),
                catchError(this._global.handleError)
            );
    }

    // Save Dashoard Config Data
    GetDashboardDataFromMongoDB(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'DashBoard' + '/GetDashboardDataFromMongoDB';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Save Dashoard Config Data
    GetRegisterMonthlyAvgValue(RegisterDataId: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'DashBoard' + '/GetRegisterMonthlyAvgValue?RegisterDataId=' + RegisterDataId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    GetDashboarddataForInsignts(obj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'DashBoard' + '/GetDashboarddataForInsignts';
        return this.http.post(serviceCallURL, obj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    getDebtronicsdashboarddata(obj: any) {

        let httpOptions = {
            headers: new HttpHeaders({
                'HideLoader': 'true'
            })
        };

        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'DashBoard' + '/GetLatestMeterValueForDashboard';
        return this.http.post(serviceCallURL, obj, httpOptions)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
}
